/* istanbul ignore file */

export default {
  "privacy-policy":
    "https://www.vodafone.it/privati/area-supporto/contratti-aggiornamenti/privacy.html?icmp=HP_FOOTER?icmp=HP_FOOTER",
  "cookie-preferences": "cookie-preferences",
  "terms-and-conditions":
    "https://www.vodafone.it/privati/area-supporto/contratti-aggiornamenti.html?icmp=HP_FOOTER?icmp=HP_FOOTER",
  "help-and-support":
    "https://privati.vodafone.it/privati/area-supporto/contattaci?icmp=HP_Footer_disclaimer%3Ficmp%3DHP_Footer_disclaimer",
};
